import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { Print } from "./Print"
import { SettleDrawer } from "./SettleDrawer"
import { OfferPrint } from "./OfferPrint"
import { SalePrint } from "./SalePrint"
import { useSaleRoModel } from "../saleRoModel"


export default () => {
    const { offerPrint, salePrint } = useSaleRoModel()

    return (
        <>
            <PageHeader />
            <DataBox />
            <Print />
            <SettleDrawer />
            {offerPrint && <OfferPrint />}
            {salePrint && <SalePrint />}

        </>
    )
}